import { useNavigate } from "react-router";
import { useShallow } from "zustand/react/shallow";

import { api } from "@api";
import { useNotifyPromise } from "@hooks";
import { IRoleEnum } from "@interfaces";
import { routePath } from "@routes/path";
import { useUserStore } from "@stores/userStore";
import { LoginForm } from "@templates/authManagement/loginForm";
import { encodePhone } from "@utils";

export function LoginView() {
  const notifyMutate = useNotifyPromise();
  const navigate = useNavigate();
  const { mutateAsync: mutate, isPending } = api.auth.signIn.usePost();
  const loginFunc = useUserStore(useShallow((state) => state.login));

  return (
    <LoginForm
      isLoading={isPending}
      onSubmit={(values) => {
        notifyMutate(
          mutate(
            {
              pathParam: undefined,
              phone_number: encodePhone(values?.phone),
              password: values.password,
            },
            {
              onSuccess: (res) => {
                loginFunc(
                  res?.data?.access,
                  res?.data?.user?.role?.id || IRoleEnum.UNKNOWN,
                  res?.data?.user?.id,
                  res?.data?.user?.store?.id || null,
                  res?.data?.user?.store?.central_warehouse_id || null,
                  res?.data?.user?.store?.scraps_warehouse_id || null,
                );
                navigate(routePath.dashboard.home());
              },
            },
          ),
        ).catch(() => {});
      }}
    />
  );
}
